/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Description or notes..." |
*
* @param {Manual_Qc_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_description_placeholder = /** @type {((inputs?: Manual_Qc_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description ou notes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibung oder Anmerkungen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione o note...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание или примечания...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción o notas...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("描述或备注……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("説明またはメモ...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विवरण या टिप्पणियाँ...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição ou notas...")
	return /** @type {LocalizedString} */ ("Description or notes...")
});